export const ADD_ETHNICITY = 'ADD_ETHNICITY';
export const DELETE_ETHNICITY = 'DELETE_ETHNICITY';
export const ADD_STUDENT_ETHNICITY = 'ADD_STUDENT_ETHNICITY';
export const DELETE_STUDENT_ETHNICITY = 'DELETE_STUDENT_ETHNICITY';